/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {ElementClassName} from './ElementClassName';
import {
  ElementClassNameFromJSON,
  ElementClassNameFromJSONTyped,
  ElementClassNameToJSON
} from './ElementClassName';

/**
 *
 * @export
 * @interface DefaultModelIn
 */
export interface DefaultModelIn {
  /**
   *
   * @type {ElementClassName}
   * @memberof DefaultModelIn
   */
  elementName: ElementClassName;
  /**
   *
   * @type {string}
   * @memberof DefaultModelIn
   */
  modelTypeUuid: string;
}

/**
 * Check if a given object implements the DefaultModelIn interface.
 */
export function instanceOfDefaultModelIn(value: object): value is DefaultModelIn {
  if (!('elementName' in value) || value['elementName'] === undefined) return false;
  if (!('modelTypeUuid' in value) || value['modelTypeUuid'] === undefined) return false;
  return true;
}

export function DefaultModelInFromJSON(json: any): DefaultModelIn {
  return DefaultModelInFromJSONTyped(json, false);
}

export function DefaultModelInFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DefaultModelIn {
  if (json == null) {
    return json;
  }
  return {
    elementName: ElementClassNameFromJSON(json['element_name']),
    modelTypeUuid: json['model_type_uuid']
  };
}

export function DefaultModelInToJSON(value?: DefaultModelIn | null): any {
  if (value == null) {
    return value;
  }
  return {
    element_name: ElementClassNameToJSON(value['elementName']),
    model_type_uuid: value['modelTypeUuid']
  };
}
